import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { teamMembers } from '../data/mock';

const Team = () => {
  return (
    <div className="team-page">
      {/* Hero */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-blue-50 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">Our Compassionate Team</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Dedicated professionals committed to providing the highest quality palliative care with empathy and expertise
            </p>
          </div>
        </div>
      </section>

      {/* Team Members */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {teamMembers.map((member) => (
              <Card key={member.id} className="overflow-hidden border-none shadow-lg hover:shadow-xl transition-all group">
                <div className="relative h-80 overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
                </div>
                <CardContent className="p-6 -mt-20 relative z-10">
                  <div className="bg-white rounded-2xl p-6 shadow-lg">
                    <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                    <p className="text-blue-600 font-medium mb-2">{member.role}</p>
                    <p className="text-sm text-gray-600 mb-3">{member.qualifications}</p>
                    <p className="text-sm text-gray-700">{member.description}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Team Values */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">What Drives Us</h2>
              <p className="text-lg text-gray-600">
                Our team is united by a shared commitment to compassionate, patient-centered care
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              {[
                {
                  title: "Expertise & Experience",
                  desc: "Our multidisciplinary team brings together specialists in palliative medicine, neurology, psychology, and nursing—all with extensive experience in end-of-life care."
                },
                {
                  title: "Compassionate Communication",
                  desc: "We believe in open, honest communication. Our team takes time to listen, understand your concerns, and explain options in clear, compassionate language."
                },
                {
                  title: "Holistic Approach",
                  desc: "We address not just physical symptoms, but emotional, spiritual, and practical needs—supporting the whole person and their entire family."
                },
                {
                  title: "Continuous Support",
                  desc: "Our commitment doesn't end at office hours. We provide 24/7 availability for urgent concerns and ongoing guidance throughout your journey."
                }
              ].map((value, index) => (
                <Card key={index} className="border-l-4 border-l-blue-600 shadow-md">
                  <CardContent className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{value.title}</h3>
                    <p className="text-gray-600">{value.desc}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Join Our Mission */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <div className="bg-gradient-to-br from-blue-50 to-white rounded-3xl p-12 border border-blue-200">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Join Our Mission</h2>
              <p className="text-lg text-gray-600 mb-6">
                Are you a healthcare professional passionate about palliative care? 
                We're always looking for compassionate team members who share our values.
              </p>
              <a href="tel:9123647588">
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-medium shadow-lg transition-all">
                  Get in Touch
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;
